<template>
    <div class="wrapper bgBlue">
        <div class="wrap header_wrapper">
            <div class="logo_city">
                <img src="../assets/image/coms/logo_blue.png" alt="" class="logo_img" style="margin-right: 16px">
                <div class="city_out_wrapper"  @click="changeCityShow">
                    <div class="city_wrapper baseBlue">
                        <img src="../assets/image/coms/address_icon_white.png"/>
                        <span>{{default_city}}</span>
                        <i class="el-icon-arrow-down"></i>
                    </div>
                    <div class="list_wrapper" v-if="city_show">
                        <template v-for="(item,index) in city_list">
                            <span :key="index" @click.stop="changeCity(item)">{{item.city_name}}</span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="menu">
                <template v-for="(item,index) in menu_list">
                    <li :key="index" @click="changeMenu(item)">
                        <a :class="currPath==item.path ? 'activeMenu' : ''">{{item.name}}</a>
                    </li>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

    import cache_city from "../cache/cache_city";
    import lib_expo from "../libs/lib_expo";
    import _object from "../utils/_object";
    import _config from "../common/_config";

    export default {
        name: "whiteheader",
        data() {
            return {
                default_city: '',
                city_show: false,
                city_list: [],
                menu_list: [
                    {path: _config.prefix + '/home', name: '首页'},
                    {path: _config.prefix + '/news', name: '行业新闻'},
                    {path: _config.prefix + '/guide', name: '家装指南'},
                    {path: _config.prefix + '/expo', name: '乐居家博会'}
                ],
                currPath: _config.prefix + '/home'
            }
        },
        created() {
            lib_expo.minilist(this.init_city);

            this.currPath = this.$route.path;

        },
        methods: {
            // city列表的显隐
            init_city(data) {
                this.city_list = data;


                this.default_city = cache_city.get()
                if (this.default_city) {
                    for (let i in this.city_list) {
                        if (this.default_city == this.city_list[i].city_name) {
                            this.set_city(this.default_city)
                            return;
                        }

                    }
                    this.set_city('')
                }

                if (!this.default_city && _object._length(this.city_list) > 0) {
                    this.set_city(this.city_list[0].city_name)
                    return;
                }

                this.set_city('')
            },

            //修改城市
            set_city(city_name){
                cache_city.set(city_name)
                this.default_city = city_name
                this.$emit('getCity', this.default_city)
            },

            changeCityShow() {
                this.city_show = !this.city_show;
            },
            // 路由切换
            changeMenu(item) {
                this.currPath = item.path;
                this.$router.push(item.path)
            },
            // 切换城市
            changeCity(item) {
                this.set_city(item.city_name)
                this.city_show = false;
                // 存储城市
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/style/coms/blueheader.less";

</style>
